var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_admin_leaveApplication_list_title"),
      addBtn: "",
      pad: "0",
    },
    on: { new: _vm.toNew },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                height: _vm.$vuetify.breakpoint.height - 275,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback) {
                  _vm.getList(page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.applicant",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "300px" } },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "pa-0",
                              attrs: { dense: "", "two-line": "" },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                {
                                  staticClass: "mr-1 my-0",
                                  attrs: { size: "36" },
                                },
                                [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      src: item.agent_staff.staff_avatar,
                                      staff_name:
                                        item.agent_staff.preferred_name,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticClass: "table-title text--primary",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.agent_staff.preferred_name
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text--secondary text-caption-xs",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.agent_staff.staff_code
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass:
                                        "table-subtitle text--secondary",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.agent_staff.job_post_name
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.type",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.leave_type_name)
                            ) +
                            " "
                        ),
                        Number(item.cancel_flag) == 1
                          ? _c("span", [
                              _vm._v(
                                "(" +
                                  _vm._s(
                                    _vm.$t(
                                      "label_essweb_LeaveApplication_list_tag_cancelLabel"
                                    )
                                  ) +
                                  ")"
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.startDate",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(
                                item.start_utc_datetime,
                                "YYYY/MM/DD"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "table-subtitle text--secondary" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getDateTime(
                                  item.start_utc_datetime,
                                  "HH:mm"
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.endDate",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(
                                item.end_utc_datetime,
                                "YYYY/MM/DD"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "table-subtitle text--secondary" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getDateTime(item.end_utc_datetime, "HH:mm")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.unit",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$getCommonLangValue(item.unit)) + " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.total",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(parseFloat(Number(item.total_time))) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.applicationDate",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getDateTime(
                                item.submission_utc_datetime,
                                "YYYY/MM/DD"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("StatusChip", {
                        attrs: {
                          slideColor: item.approval_tint_color,
                          bgColor: item.approval_bg_color,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "status",
                              fn: function () {
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$getCommonLangValue(
                                          item.status_detail
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.toView(item.uuid)
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            attrs: {
                              size: "24",
                              fill: "currentColor",
                              iconClass: "viewDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("toApply", {
              attrs: {
                staff_uuid: _vm.page_params ? _vm.page_params.staff_uuid : null,
                show: _vm.showApply,
              },
              on: {
                close: function ($event) {
                  _vm.showApply = false
                },
                toApply: _vm.toApply,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }